import { BaseEntity } from './base-entity';

export class RiskDetail extends BaseEntity {
  rank: number;
  answersTemplate: Array<AnswerTemplate>;
}

export class AnswerTemplate extends BaseEntity {
  answerRankAverage: number;
}
